import script from "./CustomerMoreSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerMoreSetting.vue?vue&type=script&setup=true&lang=js"

import "./CustomerMoreSetting.vue?vue&type=style&index=0&id=69cd4e93&scoped=true&lang=less"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69cd4e93"]])

export default __exports__